import ReactDOM from 'react-dom/client';
import AppRoot from './AppRoot.js';
// The application's global stylesheets load with App (App.js, FE-04); the
// sign-in screen carries its own (AuthScreen.css, SignInGate.css).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppRoot />);
